import { formatNumber } from "@SeemplicityDev/shared";
import React from "react";
import useAddRef, { UseAddRefOptions } from "../useAddRef";

interface TopQueuesPageProps extends UseAddRefOptions {
  data?: {
    opened_tickets_count: number;
    opened_findings_count: number;
    closed_tickets_count: number;
    closed_findings_count: number;
    queues: {
      name: string;
      closed_findings_count: number;
      opened_tickets_count: number;
      closed_tickets_count: number;
      avg_ticket_time: number;
    }[];
  };
  hasAssignees?: boolean;
}

const TopQueuesPage: React.FC<TopQueuesPageProps> = ({
  data,
  hasAssignees,
  addRef,
}) => {
  const ref = useAddRef({ addRef });
  const {
    opened_tickets_count,
    opened_findings_count,
    closed_tickets_count,
    closed_findings_count,
    queues,
  } = data || {};
  return (
    <div className={`eoy-page top-queues-page`} ref={ref}>
      {!hasAssignees && (
        <h4>
          <span className="main">
            {" "}
            Closed {formatNumber(closed_tickets_count)} Tickets for{" "}
            {formatNumber(closed_findings_count)} Findings*:{" "}
          </span>
          <span className="sub">
            You opened {formatNumber(opened_tickets_count)} tickets for{" "}
            {formatNumber(opened_findings_count)} findings
          </span>
        </h4>
      )}
      <h5>Top 3 Automations:</h5>
      <div className="rmqs-grid">
        <span className="side-header side-header-1">Ticket Avg Age</span>
        <span className="side-header side-header-2">Open Tickets</span>
        <span className="side-header side-header-3">Closed Tickets</span>
        <span className="side-header side-header-4">Closed Findings</span>
        {queues?.map((queue, index) => (
          <React.Fragment key={index}>
            <span className={`top-header top-header-${index + 1}`}>
              {queue.name}
            </span>
            <span className={`value avg-age-value avg-age-value-${index + 1}`}>
              {formatNumber(queue.avg_ticket_time)} days
            </span>
            <span
              className={`value open-tickets-value open-tickets-value-${index + 1}`}
            >
              {formatNumber(queue.opened_tickets_count)}
            </span>
            <span
              className={`value closed-tickets-value closed-tickets-value-${index + 1}`}
            >
              {formatNumber(queue.closed_tickets_count)}
            </span>
            <span
              className={`value closed-findings-value closed-findings-value-${index + 1}`}
            >
              {formatNumber(queue.closed_findings_count)}
            </span>
          </React.Fragment>
        ))}
      </div>
      {!hasAssignees && (
        <div className="disclaimer">*Some tickets were opened before 2025</div>
      )}
    </div>
  );
};

export default TopQueuesPage;
